module.exports = __webpack_public_path__ + "svg_80x80/chalice.3bcbe6.svg";